<template>
    <EntryContainer>
        <MainCard>
            <div class="headline text-center">
                {{ $t("You are invited to join") }}<br>
                {{ companyName }}
            </div>
            <v-row no-gutters justify="center" class="body-2 mt-5">
                <v-btn color="primary" large class="white--text mt-2" :loading="loading" @click="onAcceptInvitationClick">
                    <span class="pr-2">{{ $t("Accept invitation") }}</span>
                    <v-icon right>
                        mdi-check
                    </v-icon>
                </v-btn>
            </v-row>
        </MainCard>
        <ErrorDialog/>
    </EntryContainer>
</template>

<script>
import {ref, onMounted} from "@vue/composition-api";
import EntryContainer from "./EntryContainer";
import AccountModule from "../../store/modules/account";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import router from "../../router";
import AppModule from "@/store/modules/app"
import ApiInvitation from "@/api/invitation/invitation";
import {startLoginProcess} from "@/modules/auth/microsoftAuth";
import ErrorDialog from "@/views/ErrorDialog";
import MainCard from "@/components/MainCard/Index";
import {uku_send_event, UKU_ACTIVITIES} from "@/helpers/uku_activity";

export default {
    name: "InvitationAccept",
    components: {
        MainCard,
        EntryContainer,
        ErrorDialog
    },
    beforeRouteEnter(to, from, next) {
        if (to.query.n && to.query.e && to.query.ih) {
            return next();
        }
        return next({name: "login"});
    },
    setup(props, ctx) {
        const {hashLoginForJoin, current_account} = AccountModule();
        const appModule = AppModule();
        const loading = ref(false);

        const tryHashLogin = async () => {
            const res = await hashLoginForJoin(ctx.root._route.query);
            if (!res.success) {
                await router.push({name: "login"});
            }
        };

        const getMicrosoftToken = async () => {
            const loginResponse = await startLoginProcess(appModule.azure_ad_app_id.value, current_account.value.email)
            if (loginResponse) {
                return loginResponse['idToken']
            }
        }

        const attemptAcceptInvitation = async (microsoftToken) => {
            await ApiInvitation.acceptInvitation(router.currentRoute.query.ih, microsoftToken);
            await appModule.fetchInitialData(true);

            await uku_send_event({event: UKU_ACTIVITIES.INVITE_ACCEPTED, info: "InvitationAccept.attemptAcceptInvitation"})

            ctx.root._router.push({name: "dashboard"});
        }

        const onAcceptInvitationClick = async () => {
            loading.value = true;

            try {
                await attemptAcceptInvitation(null);
            } catch (e) {
                if (e.response && e.response.data && e.response.data.error_type === 'form_validation' && e.response.data.errors.length && e.response.data.errors[0].field === 'microsoft_token') {
                    const microsoftToken = await getMicrosoftToken()
                    try {
                        await attemptAcceptInvitation(microsoftToken)
                    } catch (e) {
                        errorDialog.showError(e);
                    }
                } else {
                    errorDialog.showError(e);
                }
            }

            loading.value = false
        };

        tryHashLogin();

        const urlParams = new URLSearchParams(window.location.search);
        const companyName = (urlParams.get('cn') || '').replace('+', ' ')

        onMounted(async () => {
            await uku_send_event({event: UKU_ACTIVITIES.INVITE_OPENED, info: "InvitationAccept.onMounted"})
        })

        return {
            loading,
            onAcceptInvitationClick,
            companyName
        };
    }
};
</script>
